import { Row, Col, Button } from "react-bootstrap";
import { AppRoleDef, RoleDef, UserInfo } from "../../api/users/actions";
import Label from "../../components/Label";
import CookieButton from "../../components/Cookie";
import { ReactComponent as AddIcon} from "../../svgs/add.svg"
import { ReactComponent as RefreshIcon} from "../../svgs/refresh.svg"
import { useUser } from "../../api/users/store";
import RoleSelector from "./RoleSelector";
import useUXStore from "../../api/ux/store";
import { AppRole } from "../../api/reg/actions";
import { OWNER_ROLE } from "../../constants";
import { useState } from "react";
import { useReg } from "../../api/reg/store";

type RoleAssignItemProps = {
    appRole : AppRoleDef
    edit? : boolean
    email : string
    showAdd? : boolean
    onAdd? : (approle:AppRoleDef) => void
    onRemoved? : (role:RoleDef) => void
}

type RoleAssignProps = {
    user    : UserInfo
    edit    : boolean
}

const AddRoleButton = ({defs={},email="",onConfirm=(roles:AppRole[])=>{}}) => {
    const { refreshDialog } = useUXStore( state => state)
    const onAdd = () => {
        refreshDialog({
            id: "roleBtn",
            title: "Update Role",
            content: <RoleSelector defs={defs} email={email} onConfirm={onConfirm}/>,
            visible: true,
        }, true)
    }
    return (<Col style={{padding:"0"}}>
        <Button style={{padding:"2px 0"}} size="sm" variant="" onClick={onAdd}>
            <AddIcon stroke="rgb(103, 158, 255)"/>
        </Button>
    </Col>)
}

const RoleAssignItem : React.FC<RoleAssignItemProps> = ({
    email, appRole,edit=false, showAdd=false, onAdd, onRemoved}) => {
    const {hasUserRole,updateRoles, getUserAccess} = useUser(state => state)
    const {invite} = useReg(state => state)
    const { addToast } = useUXStore(state => state)
    const [isResending, setIsResending] = useState(false)
    const [resendDisabledUntil, setResendDisabledUntil] = useState<number>(0)
    
    const _onRemoved = (role:RoleDef) => {
        const ac = getUserAccess(email, appRole!.id)
        const roles = ac!.roles!.filter(r => r !== role.id)
        updateRoles(email, 
            [{app: appRole.id, roles: roles}])
    }
    const _onAdd = () => {
    }
    
    const handleResend = async () => {
        setIsResending(true)
        const ac = getUserAccess(email, appRole!.id)
        if (ac && ac.roles) {
            try {
                await invite(email, [{app: appRole.id, roles: ac.roles}])
                // Disable button for 30 seconds
                setResendDisabledUntil(Date.now() + 30000)
                setTimeout(() => setResendDisabledUntil(0), 30000)
                addToast("Invitation Resent", `Successfully resent invitation to ${email} for ${appRole.name}`, new Date(), "success")
            } catch (error) {
                console.error("Failed to resend invite:", error)
                addToast("Resend Failed", `Failed to resend invitation to ${email}`, new Date(), "danger")
            }
        }
        setIsResending(false)
    }
    
    if (!appRole.roles) return <></>

    const roles = appRole.roles!.filter(role => hasUserRole(email, appRole.id, [role.id]))
    if (roles.length === 0) return (<></>)
    
    const owner = hasUserRole(email, appRole.id, [OWNER_ROLE])
    const status = getUserAccess(email, appRole!.id)?.status
    const isPending = status === "pending"
    const isResendDisabled = isResending || Date.now() < resendDisabledUntil
    
    let name = appRole.name
    if (isPending) name += " (pending)"
    
    return (
        <div>
            <Row>
                <Col xs="auto">
                    <Label size="medium" color="black" textAlign="left" padding="0">{name}</Label>
                </Col>
                {isPending && edit && (
                    <Col xs="auto">
                        <Button 
                            size="sm" 
                            variant="outline-primary"
                            onClick={handleResend}
                            disabled={isResendDisabled}
                            style={{padding: "2px 8px", fontSize: "12px"}}
                        >
                            <RefreshIcon style={{width: "14px", height: "14px", marginRight: "4px"}} />
                            Resend
                        </Button>
                    </Col>
                )}
            </Row>
            <Row xs="auto" style={{paddingLeft:"15px"}}>
                {roles && roles.map(role => 
                <Col md="auto" key={"rl"+role.id} style={{padding:"2px"}} >
                     {hasUserRole(email, appRole.id, [role.id])? <CookieButton 
                        bgColor={!owner? "": "rgb(0, 0, 0)"}
                        edit={edit} 
                        onRemoved={() => _onRemoved(role)}>
                        {role.name}
                    </CookieButton>: <></>}
                </Col>)}
                {showAdd && edit && appRole.roles && appRole.roles.length > 0 && <AddRoleButton defs={appRole.roles} email={email}/>}
            </Row>
        </div>
    )
}

const RoleAssign : React.FC<RoleAssignProps> = ({user, edit}) => {
    const {roles, updateRoles} = useUser(state => state)
    const onAdded = (roles:AppRole[]) => {
        //console.log(roles)
        updateRoles(user!.email, roles)
    }
    // TODO: user should be able to check role access status. was it accepted. Or need to resend
    return <>
        <Row>
            <Col xs="auto">
            <Label padding="0" textAlign="left">Roles</Label>
            </Col>
            <Col style={{padding:0}}>
                {edit && <AddRoleButton defs={roles!} email={user?.email} onConfirm={onAdded}/>}
            </Col>
        </Row> 
        {Object.keys(roles!).map( (app,i) => 
            <RoleAssignItem email={user!.email} key={"rolea" + i} edit={edit} appRole={roles![app]!} />)}
    </>
}

export default RoleAssign;